// extracted by mini-css-extract-plugin
export var bubble = "_3o-0";
export var container = "_3o-3";
export var contrastBorder = "_3o-4";
export var greyOut = "_3o-2";
export var initialsWrapper = "_3o-1";
export var large = "_3o-9";
export var medium = "_3o-8";
export var mediumSmall = "_3o-7";
export var mediumSmallMedium = "_3o-c";
export var micro = "_3o-5";
export var small = "_3o-6";
export var tiny = "_3o-b";
export var xTiny = "_3o-a";